// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"74a810af","126":"bbd77d43","228":"0c2f8f4e","326":"b05bbeac","390":"9d4b34e1","435":"cc478b59","631":"510d922b","794":"105f7549","811":"afdb0d5c"}[chunkId] + ".chunk.js";
};